import { ModalHeader } from '@components/App/Modal/components/ModalHeader'
import type { SeoFormValues } from '@store/reducers/seo/types'
import type React from 'react'
import { useSelector } from 'react-redux'

import type { AppState, ModalProps } from '@/types'
import { SearchResults, Tabs } from './components'
import css from './styles.module.css'

export const SeoPreview: React.FC<ModalProps> = ({ onClose }) => {
  const form = useSelector<AppState, SeoFormValues>(({ seoForm }) => seoForm)

  return (
    <div className={css.seo_preview}>
      <ModalHeader title="Preview" onClose={onClose} />
      <div className={css.seo_preview_body}>
        <SearchResults {...form} />

        <Tabs />
      </div>
    </div>
  )
}
